import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const LIBRARIES = gql`
  query Libraries($filter: LibraryFilter, $sort: LibrarySort) {
    libraries(filter: $filter, sort: $sort) {
      count
      data {
        id
        name
      }
    }
  }
`;

export const NEW_ORDERS_ADMIN = gql`
  query NewOrdersAdmin($filter: OrdersAdminFilter, $sort: AdminOrderSort) {
    newOrdersAdmin(filter: $filter, sort: $sort) {
      count
      data {
        libraryId
        name
        libraryNumber
        orderCount
      }
    }
  }
`;

export const PINCODE_WISE_NEW_ORDER_COUNT = gql`
  query PincodeWiseNewOrdersCount($where: LibraryUniqueInput) {
    pincodeWiseNewOrdersCount(where: $where) {
      data {
        userNumber
        orderCount
        pincode
        pincodeId
        firstName
        lastName
        userId
      }
    }
  }
`;

export const NEW_RETURN_ORDER_ADMIN = gql`
  query NewReturnOrderAdmin(
    $filter: OrdersAdminFilter
    $sort: ReturnAdminOrderSort
  ) {
    newReturnOrderAdmin(filter: $filter, sort: $sort) {
      count
      data {
        pincodeId
        pincode
        returnOrderCount
        firstName
        lastName
        userId
        userNumber
      }
    }
  }
`;

export const NEW_RETURN_ORDER_DETAILS_ADMIN = gql`
  query NewReturnOrderDetailsAdmin(
    $where: PincodeUniqueInput!
    $filter: OrdersAdminFilter
    $sort: ReturnAdminOrderSort
  ) {
    newReturnOrderDetailsAdmin(where: $where, filter: $filter, sort: $sort) {
      count
      data {
        firstName
        lastName
        name
        libraryNumber
        returnOrderCount
        userNumber
        userId
      }
    }
  }
`;

export const NEW_ORDERS_ADMIN_V2 = gql`
  query NewOrdersAdminV2($filter: OrderFilter, $sort: OrderSort) {
    newOrdersAdminV2(filter: $filter, sort: $sort) {
      count
      placedOrderCount
      confirmedOrderCount
      data {
        isExpressDelivery
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        transferOrderItemCount
        orderNumber
        metadata
        id
        deliveryType
        orderItemCount
        deliveryAttachments {
          key
          url
        }
        cancelledBy
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
        }
        pincode {
          pincode
        }
        library {
          name
          id
          libraryNumber
        }
        user {
          id
          userNumber
          firstName
          lastName
          pincode {
            pincode
          }
        }
        createdAt
        status
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }
        currentStatusTime
        nextStatusTime
      }
      configs {
        id
        key
        type
        value
      }
    }
  }
`;

export const NEW_ORDERS_COUNT_ADMIN_V2 = gql`
  query NewOrdersAdminV2($filter: OrderFilter, $sort: OrderSort) {
    newOrdersAdminV2(filter: $filter, sort: $sort) {
      count
      placedOrderCount
      confirmedOrderCount
    }
  }
`;

export const NEW_RETURN_ORDER_COUNT_ADMIN = gql`
  query returnOrdersAdmin(
    $filter: ReturnOrderItemFilter
    $sort: ReturnOrderSort
  ) {
    returnOrdersAdmin(filter: $filter, sort: $sort) {
      count
      returnRequestedOrderCount
    }
  }
`;

export const USER_ORDERS_ADMIN = gql`
  query userOrdersWithItems(
    $filter: UserOrdersWithItemsFilter
    $sort: OrderSort
    $where: UserUniqueInput!
  ) {
    userOrdersWithItems(filter: $filter, sort: $sort, where: $where) {
      count
      data {
        totalOrdersCount
        isFirstOrder
        delayedInConfirmed
        transferOrderItemCount
        orderNumber
        metadata
        id
        deliveryType
        orderItemCount
        deliveryAttachments {
          key
          url
        }
        cancelledBy
        deliveredOn
        deliveryPartner {
          id
          userNumber
          firstName
          lastName
        }
        pincode {
          pincode
        }
        library {
          name
          id
          libraryNumber
        }
        user {
          id
          userNumber
          firstName
          lastName
          pincode {
            pincode
          }
        }
        createdAt
        status
        cancellationData {
          date
          additionalComment
          reason
          type
        }
        comment {
          isResolved
          comment
        }

        statusHistory {
          newStatus
          oldStatus
          createdAt
        }
      }
    }
  }
`;
